/* Reglas de validación del evento, únicas para crear y editar.
 *
 * Antes cada vista tenía su propio juego de reglas: la edición no validaba
 * fechas ni exigía tipo de evento, y los mensajes no coincidían. El backend
 * tiene el espejo de estas reglas en controllers/eventos/service.go. */

const soloTexto = (html) =>
  (html || "")
    .replace(/<[^>]*>/g, "")
    .replace(/&nbsp;/g, " ")
    .trim();

export const validarEvento = (form) => {
  const errores = {};

  // --- contenido visual ---
  if (!form.media?.length) {
    errores.files = "Debés subir al menos una imagen o video para el evento.";
  }

  // --- nombre y descripción ---
  const nombre = (form.evento || "").trim();
  if (!nombre) {
    errores.evento = "El nombre del evento no puede estar vacío.";
  } else if (nombre.length < 5) {
    errores.evento = "El nombre del evento debe tener al menos 5 caracteres.";
  } else if (nombre.length > 50) {
    errores.evento = "El nombre del evento no puede exceder 50 caracteres.";
  }

  const descripcion = soloTexto(form.descripcion);
  if (!descripcion) {
    errores.descripcion = "La descripción es obligatoria.";
  } else if (descripcion.length < 5) {
    errores.descripcion = "La descripción necesita al menos 5 caracteres.";
  }

  // --- fechas ---
  const fechas = form.fechas || [];
  const incompleta = fechas.some(
    (f) => !f.fecha || !f.hora_inicio || !f.hora_fin
  );
  if (!fechas.length || incompleta) {
    errores.fecha =
      "Completá la fecha, hora de inicio y hora de finalización del evento.";
  } else if (fechas.every((f) => f.oculta)) {
    errores.fecha = "Dejá al menos una fecha visible.";
  }

  // --- ubicación ---
  if (!form.ciudad || !(form.direccion || "").trim()) {
    errores.direccion =
      "Seleccioná una provincia, ciudad e ingresá la dirección del evento.";
  }

  // --- detalles ---
  if (!form.eventos_tipos_id) {
    errores.eventos_tipos_id = "Seleccioná el tipo de evento.";
  }

  if (form.privado === null || form.privado === undefined || form.privado === "") {
    errores.publicoprivado = "Seleccioná si el evento es público o privado.";
  }

  // --- sponsors: si tiene imagen, necesita nombre y viceversa ---
  const sponsorIncompleto = (form.sponsors || []).some(
    (s) => Boolean(s.nombre?.trim()) !== Boolean(s.url)
  );
  if (sponsorIncompleto) {
    errores.sponsors = "Cada sponsor necesita un nombre y una imagen.";
  }

  return errores;
};

export const hayErrores = (errores) => Object.keys(errores || {}).length > 0;
